import lazyLoadWithRetry from 'utils/lazyLoadWithRetry';

export const SalaryExplainerWrapper = lazyLoadWithRetry(
  () => import('components/AiSalaryExplainer/SalaryExplainer'),
);


export const AssetGallery =
  process.env.NODE_ENV === 'production'
    ? null
    : lazyLoadWithRetry(() => import('components/AssetGallery'));
